import DocumentIcon from '../../assets/icons/check-document-icon.svg';
import PeopleIcon from '../../assets/icons/people-icon.svg';
import DependentsPetsIcon from '../../assets/icons/dependents-pets-icon.svg';
import AccountsAssetsIcon from '../../assets/icons/accounts-assets-icon.svg';
import DocumentsIcon from '../../assets/icons/documents-icon.svg';
import MemoriesIcon from '../../assets/icons/memories-icon.svg';

import type { NavGroup } from './navigationConfig';

export function createExecutorNav(estateId: string): NavGroup[] {
  const base = `/executor-plan/${estateId}`;

  return [
    {
      title: 'Dashboard',
      sections: [
        {
          title: '',
          items: [
            {
              label: 'Plan Summary',
              path: `${base}/eframe-141`,
              match: 'exact',
              icon: DocumentIcon,
            },
          ],
        },
      ],
    },
    {
      title: 'Records',
      sections: [
        {
          title: '',
          items: [
            {
              label: 'People',
              path: `${base}/eframe-142`,
              match: 'exact',
              icon: PeopleIcon,
            },
            {
              label: 'Dependents and Pets',
              path: `${base}/eframe-146`,
              match: 'exact',
              icon: DependentsPetsIcon,
            },
            {
              label: 'Accounts and Assets',
              path: `${base}/eframe-143`,
              match: 'exact',
              icon: AccountsAssetsIcon,
            },
            {
              label: 'Documents',
              path: `${base}/eframe-144`,
              match: 'exact',
              icon: DocumentsIcon,
            },
            {
              label: 'Memory Collections',
              path: `${base}/eframe-145`,
              match: 'exact',
              icon: MemoriesIcon,
            },
          ],
        },
      ],
    },
    {
      title: 'Account',
      sections: [
        {
          title: '',
          items: [
            {
              label: 'Settings',
              path: '/settings',
              match: 'exact',
            },
            {
              label: 'Support',
              path: '/frame-199',
              match: 'exact',
            },
          ],
        },
      ],
    },
  ];
}